import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.21.0_@parcel+watcher@2.5.6_@types+node@18.19.130_@vue+compiler-sfc@3.5.27_cac@6.7.14_d_ijnilurh2h436m7epbriqrhvu4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}